/* ************************************************************
src/index.jsx
진입점(Entry Point) 파일.
**************************************************************/

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Router from './routes/AppRoutes';
import AppTheme from './shared-theme/AppTheme'; // ⭐ 추가

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      {/* ✅ App 전체를 단 한 번만 감싼다 */}
      <AppTheme>
        <Router />
      </AppTheme>
    </React.StrictMode>
  );
}